import * as types from "../types";

const initialState = {
  userProfile: null,
  loading: false,
  error: null,
  checkboxLinkedWheel: false,
  reportModalOpen: false,
  reportInstance: null,
  reportLocation: null,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.USER_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        userProfile: {
          ...state.userProfile,
          ...action.payload,
        },
      };

    case types.USER_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.EDIT_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: { ...state.userProfile, ...action.payload },
        loading: false,
        error: null,
      };

    case types.LOGOUT:
      return initialState;

    case types.SET_CHECKBOX_LINKED_WHEEL:
      return {
        ...state,
        checkboxLinkedWheel: action.payload, // Handle the new action type
      };

    case types.SET_REPORT_MODAL_OPEN:
      return {
        ...state,
        reportModalOpen: action.payload,
      };

    case types.SET_REPORT_INSTANCE:
      return {
        ...state,
        reportInstance: action.payload,
      };

    case types.SET_REPORT_LOCATION:
      return {
        ...state,
        reportLocation: action.payload,
      };

    default:
      return state;
  }
};
